















import { Component } from 'vue-property-decorator';
import Stars from '../../ScoreInput/Stars.vue';
import ClassCES from './ClassCES';

@Component({ components: { Stars } })
export default class ClassCES7Star  extends ClassCES {}
